
export const hasDefinedMembers = (obj) => {
    return Object.values(obj).filter(v => v).length > 0
}